import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { Router, RouterLink } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../../app.state";
import {
  exportEntradas,
  loadEntradaSeleccionada,
} from "../../states/busqueda/actions";
import { selectBusqueda } from "../../states/busqueda/selector";

@Component({
  selector: "app-search-list",
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    CommonModule,
    RouterLink,
    MatIconModule,
  ],
  templateUrl: "./search-list.component.html",
  styleUrl: "./search-list.component.css",
})
export class SearchListComponent {
  public entradas$!: Observable<any[]>;
  public busqueda$!: Observable<any>;

  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {
    this.busqueda$ = this.store.select(selectBusqueda);
  }

  exportExcel() {
    this.store.dispatch(exportEntradas());
  }
  verHistorico(entrada: any) {
    console.log("entrada", entrada);
    this.router.navigate([
      "/historico",
      entrada.idTema,
      entrada.idEntrada,
      "?campo=",
      entrada.campoEncontrado,
    ]);
    this.store.dispatch(loadEntradaSeleccionada({ entrada }));
  }
  setEntrada(entrada: any) {
    this.store.dispatch(loadEntradaSeleccionada({ entrada }));
  }
}
